import { Skeleton } from '@gov-nx/component/web';
import { useGlobalLocale } from '@gov-nx/core/service';
import { Button, Icon } from '@gov-nx/ui/web';

interface EasyFormModalFooterProps {
	isLoading: boolean;
	isFormSessionLoading: boolean;
	isSubmitButtonDisabled: boolean;
	formId: string;
}

export const EasyFormModalFooter = ({
	isLoading,
	isFormSessionLoading,
	isSubmitButtonDisabled,
	formId,
}: EasyFormModalFooterProps) => {
	const { t } = useGlobalLocale();

	if (isLoading) {
		return (
			<Skeleton
				width="30%"
				height="40px"
			/>
		);
	}

	return (
		<Button
			nativeType="submit"
			isLoading={isFormSessionLoading}
			isDisabled={isSubmitButtonDisabled}
			type="solid"
			color="primary"
			size="m"
			form={formId}
			iconEnd={
				<Icon
					type="components"
					name="box-arrow-up-right"
				/>
			}>
			{t('akce.pokracovat-na-fomular')}
		</Button>
	);
};
